import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]

  upload(event) {
    const file = event.target.files[0]
    if (!file) return

    const token = document.querySelector("meta[name='csrf-token']").content
    const formData = new FormData()
    formData.append("file", file)

    fetch("/uploads", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "X-CSRF-Token": token
      },
      body: formData
    })
      .then((response) => response.json())
      .then((data) => {
        this.inputTarget.value = data.url
        event.target.value = ""
      })
  }
}
